import type { LanguageOptions } from '@common/enums/languageOptions';
import type { ISpecialism } from '@frontend/components/interfaces';
import { fetchJson } from '@frontend/store/fetch';

export async function getSpecialisms(language: LanguageOptions, signal: AbortSignal): Promise<ISpecialism[]> {
    const url = `/api/dhdThesaurus/specialisms?language=${language}`;
    const result = await fetchJson({ method: 'GET', signal, url });

    return result.json.items;
}
